import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import styled from "styled-components";
import {
  requestPasswordResetOtp,
  verifyEmailOtp,
} from "./utilities/Authentication";
import { statusFailure } from "./Constant";
import bannerImage from "../Images/banner1.png";
import Logo from "../Images/Logonew.jpeg";

export default function EmailForgotPassword() {
  const history = useHistory();
  const prefilledEmail = history?.location?.state?.email || "";
  const [step, setStep] = useState(1);
  const [errorState, setErrorState] = useState("");
  const [errorCode, setErrorCode] = useState("");
  const [email, setEmail] = useState(prefilledEmail);
  const [otp, setOtp] = useState("");
  const [challengeId, setChallengeId] = useState("");
  const [expiresAt, setExpiresAt] = useState("");
  const [timeRemaining, setTimeRemaining] = useState(0);

  useEffect(() => {
    if (!expiresAt || step !== 2) return;

    const updateTimer = () => {
      const remaining = Math.max(
        0,
        Math.floor((new Date(expiresAt).getTime() - Date.now()) / 1000)
      );
      setTimeRemaining(remaining);
    };

    updateTimer();
    const interval = setInterval(updateTimer, 1000);
    return () => clearInterval(interval);
  }, [expiresAt, step]);

  function formatTime(seconds) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`;
  }

  async function sendOtp(e) {
    e.preventDefault();
    setErrorState("");
    setErrorCode("");
    try {
      const response = await requestPasswordResetOtp({ email });
      if (response.status !== statusFailure && response.data?.challengeId) {
        setChallengeId(response.data.challengeId);
        setExpiresAt(response.data.expiresAt || "");
        setStep(2);
      } else {
        setErrorCode(response.code || "");
        setErrorState(response.message || "Unable to send OTP.");
      }
    } catch (error) {
      setErrorCode(error?.response?.data?.code || "");
      setErrorState(error?.response?.data?.message || "Unable to send OTP.");
    }
  }

  async function verifyOtp(e) {
    e.preventDefault();
    setErrorState("");
    try {
      const response = await verifyEmailOtp({ challengeId, otp });
      if (response.status !== statusFailure && response.data?.verifiedToken) {
        localStorage.setItem(
          "passwordResetEmailFlow",
          JSON.stringify({
            email,
            verifiedToken: response.data.verifiedToken,
          })
        );
        history.push("/set-password");
      } else {
        setErrorState(response.message || "Invalid OTP.");
      }
    } catch (error) {
      setErrorState(error?.response?.data?.message || "Invalid OTP.");
    }
  }

  return (
    <Root
      style={{
        background: `url(${bannerImage})`,
      }}
    >
      <div className="container">
        <img className="logo" src={Logo} alt="StoryTent logo" />
        <h1>{step === 1 ? "Forgot / Set Password" : "Verify OTP"}</h1>
        <p>
          {step === 1
            ? "Enter your email to receive a one-time password."
            : `Enter the 6-digit OTP sent to ${email}.`}
        </p>
        {errorState ? <div className="error">{errorState}</div> : null}
        {step === 1 && errorCode === "user_not_found" ? (
          <div className="register-link-wrap">
            <Link to="/register-email" className="text-link">
              Register now
            </Link>
          </div>
        ) : null}
        {step === 2 ? (
          <div className="timer">
            OTP valid for:{" "}
            <strong>{timeRemaining > 0 ? formatTime(timeRemaining) : "Expired"}</strong>
          </div>
        ) : null}

        {step === 1 ? (
          <form onSubmit={sendOtp} className="form">
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button type="submit" className="button">
              Send OTP
            </button>
          </form>
        ) : (
          <form onSubmit={verifyOtp} className="form">
            <input
              type="text"
              maxLength={6}
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              placeholder="Enter 6-digit OTP"
            />
            <button type="submit" className="button">
              Verify OTP
            </button>
            {timeRemaining === 0 ? (
              <div className="error">This OTP has expired. Please request a new one.</div>
            ) : null}
            <Link to="#" onClick={() => setStep(1)} className="text-link">
              Change email
            </Link>
          </form>
        )}

        <div className="footer-links">
          <Link to="/login" className="text-link">
            Back to login
          </Link>
        </div>
      </div>
    </Root>
  );
}

const Root = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: cover !important;
  background-position: center !important;
  padding: 24px;

  .container {
    width: 100%;
    max-width: 420px;
    background-color: #0f1817;
    border-radius: 20px;
    padding: 32px 28px;
    box-shadow: -1px 6px 30px 12px rgba(0, 0, 0, 0.45);
    text-align: center;
  }

  .logo {
    width: 80px;
    height: 80px;
    object-fit: cover;
    margin-bottom: 16px;
  }

  h1 {
    color: white;
    font-size: 28px;
    margin-bottom: 12px;
  }

  p {
    color: white;
    margin-bottom: 18px;
  }

  .error {
    color: #ff7b7b;
    margin-bottom: 12px;
    font-size: 14px;
  }

  .timer {
    color: #f6e27a;
    margin-bottom: 12px;
    font-size: 14px;
  }

  .form {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  input {
    width: 100%;
    padding: 11px 12px;
    border-radius: 8px;
    border: 1px solid #ccc;
  }

  .button {
    width: 100%;
    background-color: #6c63ff;
    color: white;
    font-weight: 600;
    cursor: pointer;
    border: none;
    border-radius: 8px;
    padding: 11px 12px;
  }

  .text-link {
    color: #8bb8ff;
    text-decoration: underline;
    font-size: 14px;
  }

  .footer-links {
    margin-top: 16px;
  }

  .register-link-wrap {
    margin-bottom: 12px;
  }
`;
